/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'

import Button from 'components/commons/button'

const DiscordServersModal = ({ collection, onClose, onSubmit }: any) => {
  const { name, image_url, status, channel_ids, slug } = collection

  const [selectedStatus, setStatus] = useState('')
  const [selectedChannelIDs, setChannelIDs] = useState(channel_ids)
  const [selectedSlugs, setSlugs] = useState(slug)

  useEffect(() => {
    if (status == null) {
      setStatus('incomplete')
    } else {
      setStatus(status)
    }
    if (slug == null) {
      setSlugs('')
    } else {
      let temp = ''
      slug.map((txt: string) => (temp += txt + ', '))
      setSlugs(temp)
    }

    if (channel_ids == null) {
      setChannelIDs('')
    } else {
      let temp = ''
      channel_ids.map((txt: string) => (temp += txt + ', '))
      setChannelIDs(temp)
    }
  }, [])

  const changeStatus = (e: any) => {
    setStatus(e.currentTarget.value)
  }

  const changeChannelIDs = (e: any) => {
    setChannelIDs(e.target.value)
  }

  const changeSlugs = (e: any) => {
    setSlugs(e.target.value)
  }

  const submit = (e: any) => {
    e.preventDefault()
    const filteredChannels = selectedChannelIDs.replaceAll(' ', '').split(',')
    if (
      filteredChannels[filteredChannels.length - 1] == '' ||
      filteredChannels[filteredChannels.length - 1] == null
    ) {
      filteredChannels.pop()
    }
    const filteredSlugs = selectedSlugs.replaceAll(' ', '').split(',')
    if (
      filteredSlugs[filteredSlugs.length - 1] == '' ||
      filteredSlugs[filteredSlugs.length - 1] == null
    ) {
      filteredSlugs.pop()
    }

    onSubmit(selectedStatus, filteredChannels, filteredSlugs, collection.id)
  }

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='border-0 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
            <form onSubmit={submit}>
              <div className='relative px-8 pt-8 flex-auto space-y-6 md:mr-10 lg:mr-10'>
                <div className='flex flex-row items-center space-x-4'>
                  <img src={image_url} width={75} />
                  <p className='font-bold'>{name}</p>
                </div>
                <div className='flex flex-row items-center space-x-2'>
                  <p style={{ marginRight: 8 }}>Status:</p>
                  <label style={{ marginRight: 8 }}>
                    <input
                      type='radio'
                      className='border-2 rounded-lg p-2'
                      name='status'
                      value='archive'
                      required={true}
                      style={{ marginRight: 4 }}
                      onChange={changeStatus}
                      checked={selectedStatus === 'archive'}
                    />
                    Archive
                  </label>
                  <label style={{ marginRight: 8 }}>
                    <input
                      type='radio'
                      className='border-2 rounded-lg p-2'
                      name='status'
                      value='incomplete'
                      required={true}
                      style={{ marginRight: 4 }}
                      onChange={changeStatus}
                      checked={selectedStatus === 'incomplete'}
                    />
                    Incomplete
                  </label>
                  <label style={{ marginRight: 8 }}>
                    <input
                      type='radio'
                      className='border-2 rounded-lg p-2'
                      name='status'
                      value='verify'
                      required={true}
                      style={{ marginRight: 4 }}
                      onChange={changeStatus}
                      checked={selectedStatus === 'verify'}
                    />
                    Verify
                  </label>
                  <label>
                    <input
                      type='radio'
                      className='border-2 rounded-lg p-2'
                      name='status'
                      value='complete'
                      required={true}
                      style={{ marginRight: 4 }}
                      onChange={changeStatus}
                      checked={selectedStatus === 'complete'}
                    />
                    Complete
                  </label>
                </div>

                <div className='flex flex-row items-center space-x-2'>
                  <p>Channel ID(s):</p>
                  <input
                    className='border-2 rounded-lg p-2'
                    value={selectedChannelIDs}
                    onChange={changeChannelIDs}
                  />
                </div>

                <div className='flex flex-row items-center space-x-2'>
                  <p>NFT Project Slug(s):</p>
                  <input
                    className='border-2 rounded-lg p-2'
                    value={selectedSlugs}
                    onChange={changeSlugs}
                  />
                </div>
              </div>
              <div className='flex items-center p-8 border-slate-200 rounded-b space-x-4'>
                <Button
                  onClick={() => onClose('form-modal')}
                  className='bg-gray-200 font-semibold border px-6'
                >
                  Cancel
                </Button>
                <Button
                  type='submit'
                  className='border border-blue-500 bg-blue-500 text-white font-semibold'
                >
                  Update Fields
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
    </>
  )
}

export default DiscordServersModal
